import {
  ACTION_DELETE_SITE_FOOTER_LINK__FAIL,
  ACTION_DELETE_SITE_FOOTER_LINK__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK__SUCCESS,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_FOOTER_LINK__REQUEST:
    case ACTION_DELETE_SITE_FOOTER_LINK__SUCCESS:
      return null;

    case ACTION_DELETE_SITE_FOOTER_LINK__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
